"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function useWindowSize() {
    var isClient = typeof window === 'object';
    function getSize() {
        return {
            width: isClient ? window.innerWidth : 9999,
            height: isClient ? window.innerHeight : 9999
        };
    }
    var _React$useState = react_1.default.useState(getSize), windowSize = _React$useState[0], setWindowSize = _React$useState[1];
    react_1.default.useEffect(function () {
        if (!isClient)
            return;
        var handleResize = function handleResize() {
            setWindowSize(getSize());
        };
        window.addEventListener('resize', handleResize);
        return function () {
            return window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
}
exports.default = useWindowSize;
